import { Divider, Space } from 'antd'
import { createStyles } from 'antd-style'

import { RouterLink } from '@eastcoal/router/components/Link'

const useStyles = createStyles(({ token }) => ({
  container: {
    paddingBlock: token.paddingLG,
    textAlign: 'center'
  },
  link: {
    display: 'inline-block',
    padding: token.paddingSM
  }
}))

const links1 = [
  {
    label: '关于我们',
    link: ''
  },
  {
    label: '网站公告',
    link: ''
  },
  {
    label: '产品服务',
    link: ''
  },
  {
    label: '人才招聘',
    link: ''
  },
  {
    label: '联系我们',
    link: ''
  }
]

const links2 = [
  {
    label: '我的钢铁',
    link: 'https://www.mysteel.com/'
  },
  {
    label: '隆众资讯',
    link: 'https://www.oilchem.net/'
  },
  {
    label: '中国人民银行征信中心',
    link: 'http://www.pbccrc.org.cn/'
  },
  {
    label: '国家企业信用信息公示系统',
    link: 'https://www.gsxt.gov.cn/index.html'
  },
  {
    label: '失信被执行人名单查询',
    link: 'http://zxgk.court.gov.cn/shixin/'
  },
  {
    label: '淮北矿业外网',
    link: 'http://www.hbcoal.com/'
  },
  {
    label: '淮河能源集团',
    link: 'http://www.hhnykg.com/'
  },
  {
    label: '皖北煤电集团',
    link: 'https://www.wbmd.cn/'
  }
]

export const ExternalLink = () => {
  const { styles } = useStyles()

  return (
    <div className={styles.container}>
      <Space separator={<Divider orientation='vertical' />} size={0}>
        {links1.map(({ label, link }) => (
          <RouterLink key={label} className={styles.link} to={link} type='text'>
            {label}
          </RouterLink>
        ))}
      </Space>
      <br />
      友情链接：
      <Space separator={<Divider orientation='vertical' />} size={0}>
        {links2.map(({ label, link }) => (
          <RouterLink key={label} className={styles.link} to={link} type='text'>
            {label}
          </RouterLink>
        ))}
      </Space>
    </div>
  )
}
